module.exports = __webpack_public_path__ + "img/logo.e702745.png";